import styled from "styled-components";

export const SupportPageWrapper = styled.div`
  .ant-card {
    border-radius: 8px;
    // box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
    box-shadow: none;
    border: 1px solid var(--border-color);
    background-color: var(--primary-color) !important;
  }
  .ant-card-body{
    padding: 20px 10px;
  }
  .ant-segmented {
    background-color: var(--border-color) !important;
  }
  .ant-segmented-item {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary-text-color) !important;

    &:hover {
      color: none !important;
    }
  }
  .ant-segmented-item-selected {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-segmented-item-label {
    font-size: 14px;
    font-weight: 600;
  }
  .ant-segmented-thumb {
  background-color: var(--primary-bg);
  }
  .ant-segmented-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color) !important;
  }
  .ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum", "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: var(--primary-text-color) !important;
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border-radius: 6px;
    border: 1px solid var(--border-color) !imortant;
    height: 40px;
    transition: all 0.3s;
    background-color: var(--primary-bg) !important;
    border-color: var(--border-color) !important;
  }
  .ant-input:focus,
  .ant-input:focus-visible .ant-input:hover {
    border-color: #8a3ef4 !important;
    color: #000;
  }
   .ant-collapse{
     background-color: var(--primary-bg) !important;
     border-bottom: 1px solid var(--border-color) !important;
     cursor: pointer;
   }
  .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-header-text {
    font-weight: 600;
    color: var(--primary-text-color);
    font-size: 17px;

    &:hover{
       text-decoration: underline;
     }
  }
  .ant-collapse-expand-icon{
   color: var(--primary-text-color);
  }
  .ant-collapse-content{
    color: var(--primary-text-color);
  }
  .ant-collapse-content p{
    font-size: 16px;
    font-weight: 500;
  }
  .ant-collapse-header{
    padding: 12px 40px 12px 2px !important;
  }
`;
